import { DropdownItem } from '@optimus-web/core';
import { LocalizedProperty } from '@mews/framework';
import { LocalizedDateFromUtc, SpacedDash, SpacedPipe } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { ReservationLinkResult } from '@mews-commander/data-access';
import { ReservationTimeState, ServiceOrderState } from '@mews-commander/legacy-data-structures';
import { getFullName, localizeCurrencyValue } from '@mews-commander/utils';
import { ReservationStateTag } from '../../../../components/reservation/ReservationStateTag';

export const renderReservationItem = (r: ReservationLinkResult) => {
    const primaryText = (
        <>
            {r.ownerFirstName || r.ownerLastName ? (
                <>
                    {getFullName({ firstName: r.ownerFirstName, lastName: r.ownerLastName })}
                    {SpacedDash}
                </>
            ) : null}
            {r.serviceNames ? (
                <>
                    <LocalizedProperty property={r.serviceNames} />
                    {UnicodeEntity.NoBreakSpace}
                </>
            ) : null}
            {r.reservationNumber}
        </>
    );

    const description = `${r.resourceCategoryShortName ?? ''} ${r.resourceName ?? ''}`.trim();
    const reservationPrice = localizeCurrencyValue(r.reservationTotalPrice);
    const secondaryText = (
        <>
            <LocalizedDateFromUtc utcString={r.reservationStartUtc} />
            {SpacedDash}
            <LocalizedDateFromUtc utcString={r.reservationEndUtc} />
            {description ? `${SpacedPipe}${description}` : null}
            {SpacedPipe}
            {reservationPrice}
        </>
    );

    const rightItem =
        r.serviceOrderState != null && r.reservationTimeState != null ? (
            <ReservationStateTag
                state={ServiceOrderState.getByName(r.serviceOrderState)}
                timeState={ReservationTimeState.getByName(r.reservationTimeState)}
                options={r.reservationOptions}
            />
        ) : null;

    return (
        <DropdownItem
            key={r.reservationId}
            value={r.reservationId}
            label={primaryText}
            description={secondaryText}
            rightDetail={rightItem}
        />
    );
};
